export class AsyncStorage {
  constructor(storage = window.localStorage) {
    this.storage = storage;
  }

  /**
   * Check availability of Local or Session storage.
   * @private
   * @returns {Promise<boolean>}
   */
  async isStorageAvailable() {
    const test = 'test';
    try {
      this.storage.setItem(test, test);
      this.storage.removeItem(test);
      return true;
    } catch (error) {
      return false;
    }
  }

  /**
   * Wraps Storage.setItem in a Promise.
   * @param key
   * @param value
   * @returns {Promise<boolean>}
   */
  async setItem(key, value) {
    const state = await this.isStorageAvailable();
    if (!state) {
      console.error('Storage unavailable.');
      return Promise.resolve(null);
    }

    let parsed;

    try {
      parsed = JSON.stringify(value);
    } catch (error) {
      console.error(`JSON.stringify for ${key} failed.`);
      return Promise.resolve(null);
    }

    try {
      this.storage.setItem(key, parsed);
      return Promise.resolve(true);
    } catch (error) {
      console.error(`Storage.getItem failed for ${key}.`);
      return Promise.resolve(false);
    }
  }

  /**
   * Wrap Storage.getItem in a Promise.
   * @param key
   * @returns {Promise<unknown>}
   */
  async getItem(key) {
    const state = await this.isStorageAvailable();
    if (!state) {
      console.error('Storage unavailable.');
      return Promise.resolve(null);
    }

    try {
      const value = this.storage.getItem(key);
      let parsed;
      try {
        parsed = JSON.parse(value);
        return Promise.resolve(parsed);
      } catch (noparse) {
        console.error(`JSON.parse for ${key} failed.`);
        return Promise.resolve(null);
      }
    } catch (error) {
      console.error(`Storage.setItem failed for ${key}.`);
      return Promise.resolve(null);
    }
  }

  /**
   * Wrap Storage.removeItem in a Promise.
   * @param key
   * @returns {Promise<boolean>}
   */
  async removeItem(key) {
    const state = await this.isStorageAvailable();
    if (!state) {
      console.error('Storage unavailable.');
      return Promise.resolve(null);
    }

    try {
      this.storage.removeItem(key);
      return Promise.resolve(true);
    } catch (error) {
      console.error(`Storage.removeItem failed for ${key}.`);
      return Promise.resolve(false);
    }
  }

}
